import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getTicketLookups } from '../api/ticketRequestApi'

/** Filtre seçenekleri (durum/makam/tür). Dil değişince yeniden çeker (TR/EN adlar). */
export function useTicketLookups() {
  const { i18n } = useTranslation()
  return useQuery({
    queryKey: ['ticket-lookups', i18n.language],
    queryFn: getTicketLookups,
  })
}
